import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import AuthAxios from "../../config/authAxios"
import apiRoutes from "../apiConfigs";

export const usageSummaryGraphApi = createAsyncThunk(
    'auth/UsageSummaryGraph/graph',
    async (requestData, { rejectWithValue }) => {
        try {
            const { params } = requestData;
            const response = await AuthAxios.get(apiRoutes.usageSummaryGraph(), { params })
            return response?.data;
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)
const initialState = { result: [], loading: false, error: null, message: "" }
const usageSummaryGraphSlice = createSlice({
    name: 'UsageSummaryGraph/graph',
    initialState: initialState,
    reducers: {
        resetUsageSummaryGraph: () => initialState,
    },
    extraReducers: (builder) => {
        // eslint-disable-next-line
        builder.addCase(usageSummaryGraphApi.pending, (state, action) => {
            state.loading = true
        })
        builder.addCase(usageSummaryGraphApi.fulfilled, (state, action) => {
            state.loading = false
            state.result = action?.payload?.result || action?.payload
            state.message = action?.payload?.message
        })
        builder.addCase(usageSummaryGraphApi.rejected, (state, action) => {
            state.loading = false
            state.error = action?.payload?.error
            state.message = action?.payload?.message
        })
    },
})
export const { resetUsageSummaryGraph } = usageSummaryGraphSlice.actions;
export const usageSummaryGraphReducer = usageSummaryGraphSlice.reducer
